import React from 'react';
import './Button.css';

function Button({ 
  children, 
  href, 
  onClick, 
  variant = 'primary',
  className = '',
  ...props 
}) {
  const baseClass = 'btn';
  const variantClass = `btn-${variant}`;
  const classes = `${baseClass} ${variantClass} ${className}`.trim();

  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        <span>{children}</span>
      </a>
    );
  }

  return (
    <button type="button" onClick={onClick} className={classes} {...props}>
      <span>{children}</span>
    </button>
  );
}

export default Button;
